<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="bg_gray subject_cont">
			<div class="w1200 radius8 bs bg_white">
				<div class="test_screen cl_gray video_screen">
					<div class="test_screen_l f16px"><span class="inline">年级</span><i class="inline">：</i></div>
					<div class="test_screen_r tc">
						<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId==grade_cur.gradeId}" @click="gradeCheck(index)">{{item.gradeName}}</span>
					</div>
				</div>
				<div class="subject_cont_title mab20 mat40 flex">
					<div class="video_screen_sort flex f18px cl_dark">
						<span class="video_screen_sort_list cur" v-for="(item,index) in sort" :key="index" :class="{'on': item.type == sort_cur}"
						 @click="sortCheck(item.type)">{{item.name}}</span>
					</div>
					<div class="cl_gray f16px">共&nbsp;<span class="cl_yel">{{total}}</span>&nbsp;个视频</div>
				</div>
				<div class="search_cont" v-if="list.length > 0">
					<div class="search_list" v-for="(item,index) in list" :key="index">
						<router-link :to="{ path: '/video', query: { id: item.id}}" class="search_list_l"><img :src="item.pic" class="block radius8" /></router-link>
						<div class="search_list_r">
							<router-link :to="{ path: '/video', query: { id: item.id}}" class="f20px cl_dark">{{item.name}}</router-link>
							<div class="f16px mat10 search_list_mid">
								<span class="cl_blue">{{item.teacher_name}}</span>
								<span class="cl_gray">{{item.video.length}}播放</span>
							</div>
							<div class="search_list_btm mat10" :class="{'open' : item.open}">
								<div class="search_list_btm_item cl_dark" v-for="(item,index) in item.video" :key="index">{{item.name}}</div>
								<div class="search_list_open f14px cl_violet cur" v-if="item.video.length > 1" @click="open(index)">{{item.open ? "收起" : "展开更多"}}<img src="../../../static/select_violet.png" class="mal5" /></div>
							</div>
						</div>
					</div>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next" 
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>找不到内容，请重新选择</p>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'video_search',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				studyNav: -1,
				subjectIndex: false, //学科分类显示
				myInfo: {},
				public: {},
				name: "",
				grade: [],  //年级
				grade_cur: {}, //默认年级
				sort: [ //排序
					{
						type: "",
						name: "默认",
					},{
						type: "add_time desc",
						name: "最新",
					},{
						type: "is_hot desc",
						name: "最热",
					},
				],
				sort_cur: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 10, //每页数量
				total: 0, //总页数
			}
		},
		mounted() {
			this.getGrade();
		},
		watch: {
			$route: {
				handler () {
					this.name = this.$route.query.name;
					this.getVideo();
				}
			}
		},
		created() {
			this.name = this.$route.query.name;
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//年级
			getGrade () {
				this.$get("/api/material/get_grade_data",{
					id: localStorage.getItem("pharseId"),
				})
				.then(res => {
					this.grade = res.data;
					this.grade.unshift({gradeId: "", gradeName: "全部"});
					this.grade_cur = this.grade[0];
					this.getVideo();
				});
			},
			//视频
			getVideo () {
				this.$get("/api/course/get_course_show_list",{
					name: this.name,
					grade_id: this.grade_cur.gradeId,
					pharse_id: localStorage.getItem("pharseId"),
					sort: this.sort_cur,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = [];
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			//年级选择
			gradeCheck (e) {
				this.grade_cur = this.grade[e];
				this.getVideo();
			},
			sortCheck (e) {
				this.sort_cur = e;
				this.currentPage = 1;
				this.getVideo();
			},
			open (e) {
				if (this.list[e].open) {
					this.list[e].open = false;
				} else {
					this.list[e].open = true;
				}
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getVideo();
			},
		},
	}
</script>

<style>
</style>
